import { ServicePayLoadTemplate } from "./servicePayloadTemplate.model";

export class ServiceTemplatePayload{

  templateId: number;
  payloads: ServicePayLoadTemplate[];
}
